import {
  REQUEST_CATEGORY_PARENT_LIST,
  REQUEST_CATEGORY_LIST,
  REQUEST_CATEGORY_LIST_FOR_CREATE,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCategoryParentList({commit}) {
    return axiosInst.springAxiosInst.get('/admin/category/category-parent-list')
    .then((res) => {
      commit(REQUEST_CATEGORY_PARENT_LIST, res.data)
    })
  },

  requestCreateCategory({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/category/create-category', payload)
    .then((res) => {
      return res.data
    })
  },

  requestDeleteCategories({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/category/delete-categories', payload)
    .then((res) => {
      return res.data
    })
  },

  requestCategoryList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get('/admin/category/category-list',{
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_CATEGORY_LIST, res.data)
    })
  },

  requestCategoryListForCreate({commit}, parent) {
    return axiosInst.springAxiosInst.get('/admin/category/get-category-by-parent', {
      params: {parent: parent}
    }).then((res) => {
      commit(REQUEST_CATEGORY_LIST_FOR_CREATE, res.data)
    })
  },

  requestChangeCategoryUseYn({}, categorySeq) {
    return axiosInst.springAxiosInst.post(`/admin/category/change-category-use-yn/${categorySeq}`)
    .then((res) => {
      return res.data
    })
  },
}